import React from 'react'
import styled from 'styled-components'
import UIHours from './UI-Hours'
import UILines from './UI-Lines'
import UIPinkBlue from './UI-PinkBlue'
import Event from './Event'
import {populateBuckets} from '../helpers/functions'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  background: linear-gradient(90deg, #FEF6F8 0%, #FEF6F8 49%, #EEFEFE 50%, #EEFEFE 100%);
  z-index: -500;
`

const AllDay = styled.div`
    position: sticky;
    z-index: -100;
    top: 60px;
    display: flex;
    flex-direction: column;
    margin-left: 12rem;

    @media screen and (max-width: 400px) {
      margin-left: 0;
    }
  `

  const Grid = styled.div`
    flex-grow: 1;
    display: grid;
    grid-template-rows: repeat(48,45px);
    position: relative;
    z-index: -200;
    margin-left: 12rem;

    @media screen and (max-width: 400px) {
      margin-left: 0;
    }
  `

export default function Calendar(props) {
  if (!props.todayEvents || props.todayEvents < 1) {
    return (
      <Container>
        <Grid>
          <UIPinkBlue/>
          <UIHours/>
          <UILines/>
        </Grid>
     </Container>
    )
  }

  // We have different kinds of events in our database. We create a "bucket" for each of them. Each bucket will be responsible for the correct rendering of the Event component.
  // In arrayAlldayEvents we insert the allday events. 
  const arrayAlldayEvents = []
  // In arrayOnlyEventInItsHourSlot we insert the events that span for the whole length of the row.
  const arrayOnlyEventInItsHourSlot = []
  // In mapPlacing, the key is the length of events that share the same row, and the value is an array of events. Scroll to the end for an example.
  const mapPlacing = {}
  // We create an array to store data while looping in the populateBuckets function.
  const memoryEvents = []
  let lastEnd = null
  const sortedArray = props.todayEvents.sort((a,b) => a.start - b.start)
  populateBuckets(sortedArray, arrayAlldayEvents, arrayOnlyEventInItsHourSlot, mapPlacing, memoryEvents, lastEnd)
  const mapKeys = Object.keys(mapPlacing)

  return (
    <Container>
      <AllDay>
        {arrayAlldayEvents.map(el => <Event info={el} totlen={1} key={el.uniqueID}/>)}
      </AllDay>
      <Grid>
        <UIPinkBlue/>
        <UIHours/>
        <UILines/>
{/*         Notice how we leverage the second and third parameters of the map method to send the index of the current element and the length of the array to Event. */}
        {mapKeys.map(ciav => mapPlacing[ciav].map(arr => arr.map((el,ind,thisarr) => <Event info={el} index={ind} totlen={thisarr.length} key={el.uniqueID}/>)))}
        {arrayOnlyEventInItsHourSlot.map((el) => <Event info={el} totlen={1} key={el.uniqueID}/>)}
      </Grid>
    </Container>
  )
}


/*   Example of a mapPlacing object
 const mapPlacing = {
  "2": [
    [
      {"start":"1300","end":"1430","allday":false,"name":"Walk","location":"Central Park","uniqueID":3},
      {"start":"1400","end":"1500","allday":false,"name":"Groceries","location":"Morton & Williams","uniqueID":4}
    ],
    [
      {"start":"0800","end":"1000","allday":false,"name":"Walk","location":"Central Park","uniqueID":1},
      {"start":"0900","end":"1100","allday":false,"name":"Groceries","location":"Morton & Williams","uniqueID":2}
    ]
  ],
  "3": [
    [
      {"start":"1700","end":"1730","allday":false,"name":"Call Laundry","location":"10 Amsterdam Avenue","uniqueID":7},
      {"start":"1700","end":"2000","allday":false,"name":"TV Time","location":"Home","uniqueID":5},
      {"start":"1730","end":"1900","allday":false,"name":"Homework","location":"Coursera","uniqueID":6}
    ]
  ]
} */